"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
var CreditCardType;
(function (CreditCardType) {
    CreditCardType["VISA"] = "VISA";
    CreditCardType["MASTERCARD"] = "MASTERCARD";
    CreditCardType["AMEX"] = "AMEX";
    CreditCardType["DINERS"] = "DINERS";
    CreditCardType["DISCOVER"] = "DISCOVER";
    CreditCardType["VPAY"] = "VPAY";
    CreditCardType["OTHER"] = "OTHER";
})(CreditCardType = exports.CreditCardType || (exports.CreditCardType = {}));
class CreditCardAssignmentsProvider extends DataProvider_1.default {
    get fragments() {
        return {
            CreditCardAssignment: () => `
        ... on CreditCardAssignment {
          id
          userId
          type
          cardNumberEnding
          createTime
          publicPaymentSystem {
            ${this.getFragment("PaymentSystemPublic")}
          }
        }`,
        };
    }
    findAll({ userId }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("creditCardAssignmentsFindAll", { userId }, this.getFragment("CreditCardAssignment"));
        });
    }
    delete({ id }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("creditCardAssignmentsDelete", { id });
        });
    }
}
exports.CreditCardAssignmentsProvider = CreditCardAssignmentsProvider;
//# sourceMappingURL=CreditCardAssignmentsProvider.js.map